<template>
  <v-bottom-navigation fixed color="primary" v-if="showBottomNav">
    <v-btn :to="appRoutes.messages" v-if="$p(permissions.conversation.listing)">
      <span data-testid="bottomNav-messages">{{ $t("messages") }}</span>
      <v-badge
        color="orange"
        :value="messagesStat"
        :content="messagesStat"
        bordered
        overlap
      >
        <v-icon>mdi-chat</v-icon>
      </v-badge>
    </v-btn>
    <v-btn
      :to="appRoutes.library"
      :input-value="libraryActive"
      v-if="$p(permissions.module.join) || user.isExpert || user.isProvider"
    >
      <span>{{ $t("library") }}</span>
      <v-icon>mdi-bookshelf</v-icon>
    </v-btn>
    <v-btn
      :to="appRoutes.notifications"
      v-if="$p(permissions.notification.listing)"
    >
      <span>{{ $t("notifications") }}</span>
      <v-badge
        color="orange"
        :value="notificationsStat"
        :content="notificationsStat"
        overlap
      >
        <v-icon>mdi-bell</v-icon>
      </v-badge>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import Btn from "Shared/components/Public/General/Buttons/Btn";
import { appRoutes } from "Public/consts/appRoutes";
import checkMobileMixin from "Shared/mixins/checkMobileMixin";
import userMixin from "Shared/mixins/userMixin";
import checkTabletMixin from "Shared/mixins/checkTabletMixin";
import checkIsChatMixin from "Shared/mixins/checkIsChatMixin";
import { permissions } from "Consts/permissions";

export default {
  name: "BottomNavigation",
  mixins: [checkTabletMixin, checkMobileMixin, userMixin, checkIsChatMixin],
  components: { Btn },
  data() {
    return {
      appRoutes,
      permissions,
    };
  },
  computed: {
    showBottomNav() {
      if (this.isChat && this.mobile) return false;
      if (this.tablet || this.mobile) return true;
    },
    libraryActive() {
      return this.$route.path.includes("library");
    },
    messagesStat() {
      const { unread_count = 0 } = this.user;
      return unread_count;
    },
    notificationsStat() {
      const { unread_notifications_count = 0 } = this.user;
      return unread_notifications_count;
    },
  },
};
</script>

<style scoped></style>
